import {
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Error as ErrorIcon,
  HourglassEmpty as HourglassEmptyIcon,
  RateReview as RateReviewIcon,
  Visibility as VisibilityIcon,
} from '@mui/icons-material';

export const CertificationStatusEnumValue = {
  Pending: 1,
  InProgress: 2,
  AwaitingReview: 3,
  ReviewInProgress: 4,
  Passed: 5,
  PassedForAnotherOption: 7,
  Failed: 100,
};

export const CertificationStatusEnum = [
  {
    value: CertificationStatusEnumValue.Passed,
    name: 'Passed',
    labelFrench: 'Approuvé',
    labelEnglish: 'Approved',
    color: '#2e7d32',
    bgColor: 'rgba(46, 125, 50, 0.1)',
    icon: CheckCircleIcon,
    isFinalDecision: true,
    isFinal: true,
  },
  {
    value: CertificationStatusEnumValue.PassedForAnotherOption,
    name: 'PassedForAnotherOption',
    label: 'Certified for Another Option',
    labelFrench: 'Certifié pour une option différente',
    labelEnglish: 'Certified for a different option',
    color: '#ff9800',
    bgColor: 'rgba(255, 152, 0, 0.1)',
    icon: CheckCircleIcon,
    isFinalDecision: true,
  },
  {
    value: CertificationStatusEnumValue.Pending,
    name: 'Pending',
    labelFrench: 'En attente',
    labelEnglish: 'Pending',
    color: '#FFD200',
    bgColor: 'rgba(255, 210, 0, 0.1)',
    icon: HourglassEmptyIcon,
  },
  {
    value: CertificationStatusEnumValue.Failed,
    name: 'Failed',
    labelFrench: 'Refusé',
    labelEnglish: 'Denied',
    color: '#d32f2f',
    bgColor: 'rgba(211, 47, 47, 0.1)',
    icon: ErrorIcon,
    isFinalDecision: true,
  },
  {
    value: CertificationStatusEnumValue.InProgress,
    name: 'InProgress',
    labelFrench: 'En cours',
    labelEnglish: 'In Progress',
    color: '#00bfdf',
    bgColor: 'rgba(0, 191, 223, 0.1)',
    icon: WarningIcon,
  },
  {
    value: CertificationStatusEnumValue.AwaitingReview,
    name: 'AwaitingReview',
    labelFrench: 'En attente de révision',
    labelEnglish: 'Awaiting Review',
    color: '#ff9800',
    bgColor: 'rgba(255, 152, 0, 0.1)',
    icon: HourglassEmptyIcon,
  },
  {
    value: CertificationStatusEnumValue.ReviewInProgress,
    name: 'ReviewInProgress',
    labelFrench: 'Révision en cours',
    labelEnglish: 'Review In Progress',
    color: '#9c27b0',
    bgColor: 'rgba(156, 39, 176, 0.1)',
    icon: RateReviewIcon,
  },
];

/**
 * Get status configuration by status value
 * @param {number} statusValue - The status value from CertificationStatusEnumValue
 * @returns {Object|null} The status configuration object or null if not found
 */
export const getStatusConfig = statusValue => {
  return CertificationStatusEnum.find(status => status.value === statusValue) || null;
};

/**
 * Get localized status label
 * @param {number} statusValue - The status value from CertificationStatusEnumValue
 * @param {string} language - The current language ('en' or 'fr')
 * @returns {string} The localized label
 */
export const getStatusLabel = (statusValue, language = 'en') => {
  const config = getStatusConfig(statusValue);
  if (!config) return 'Unknown';
  return language === 'fr' ? config.labelFrench : config.labelEnglish;
};

export default CertificationStatusEnum;
